import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { connectSubpages } from 'app/hocs/subpageManagable';
import { reduxForm, formValueSelector } from 'redux-form';
import { doSearch, loadSearchForm, swapLocations } from 'app/actions/search-results';
import connectScreenSize from 'app/hocs/connectScreenSize';
import formConfig from 'app/forms/search-form';
import { IS_FLIGHT_TIME_FIELD_NAME, IS_RETURN_FLIGHT_TIME_FIELD_NAME } from 'app/constants';
import { isHourlyRideSearch, getPlaceSuggestionsParams, getEsimUrl, getParkingUrl } from 'app/sagas/selectors';


export const selector = formValueSelector(formConfig.form);

export const mapStateToProps = state => {
  const {
    searchResults: { searching }
  } = state;

  return {
    esimUrl: getEsimUrl(state),
    parkingUrl: getParkingUrl(state),
    mode: selector(state, 'mode') || 'one_way',
    booking_mode: selector(state, 'booking_mode') || 'point_to_point',
    start_address: selector(state, 'start_address'),
    end_address: selector(state, 'end_address'),
    pickup_datetime: selector(state, 'pickup_datetime'),
    return_pickup_datetime: selector(state, 'return_pickup_datetime'),
    searchQuery: selector(state, 'searchQuery'),
    useLandingTime: selector(state, IS_FLIGHT_TIME_FIELD_NAME),
    useReturnLandingTime: selector(state, IS_RETURN_FLIGHT_TIME_FIELD_NAME),
    isHourlyRideSearch: isHourlyRideSearch(state),
    searching,
    placeParams: getPlaceSuggestionsParams(state),
  };
};

export const mapDispatchToProps = { doSearch, loadSearchForm, swapLocations };

/**
 * Connect search form to the store
 * @return {Component}
 */
export default (ComposedSearchForm) => {
  return compose(
    connectSubpages(),
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
    reduxForm(formConfig),
    connectScreenSize
  )(ComposedSearchForm);
};
